import React, { Component } from 'react'
import {
  PieChart,
  LineChart as LChart,
  BarChart as BChart,
  Tooltip,
  Cell,
  Pie,
  Bar,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from 'recharts'
import './styles.css'
const X = () => (
  <XAxis
    dataKey="name"
    mirror={true}
    axisLine={false}
    tickLine={false}
    tickCountNumber={3}
    interval={9}
    scale="auto"
  />
)

const Y = (unit, max) => (
  <YAxis
    mirror={true}
    axisLine={false}
    tickLine={false}
    tickCountNumber={5}
    interval={0.5}
    scale="linear"
    domain={[0, max || 'dataMax']}
    tickFormatter={value => value.formatUnit(unit, '', 0)}
  />
)

export class LineChart extends Component {
  eachDataSeries = (item, index) =>
    item.key !== this.props.highlight && this.props.current[item.key] > 0 ? (
      <span
        key={String.GUID()}
        className={`pa1 ma1 fw4 f6 b dib bg-white o-80 br2 ${item.className ||
          ''}`}
      >
        {item.text}:{' '}
        {this.props.current[item.key].formatUnit(this.props.unit, ' ')}
      </span>
    ) : (
      false
    )
  eachSeries = (item, index) =>
    item.displayChart === false ? (
      false
    ) : (
      <Line
        key={String.GUID()}
        dataKey={item.key}
        isAnimationActiveBoolean={false}
        dot={false}
        stroke={item.stroke}
      />
    )
  render = () => (
    <div className="fl w-100 chart-container relative ">
      {this.props.current && this.props.highlight ? (
        <div className="w-100 fl tc counters absolute">
          <span className="w-100 fl f5 fw4 tc o-80">
            {this.props.title ? this.props.title : null}
            <small className="f7">
              {this.props.unit ? ` (${this.props.unit})` : null}
            </small>
          </span>
          <span className="w-100 fl f2 fw6 tc pa0">
            {this.props.current[this.props.highlight].formatUnit(
              this.props.unit,
              ' '
            )}
          </span>
          <span className="w-100 status tc pa1 dib">
            {this.props.dataSeries.map(this.eachDataSeries)}
          </span>
        </div>
      ) : (
        false
      )}
      <ResponsiveContainer
        width="100%"
        height="100%"
        minHeight={this.props.minHeight || 120}
      >
        <LChart
          data={this.props.series}
          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
        >
          {X()}
          {Y(this.props.unit, this.props.max)}
          {this.props.dataSeries.map(this.eachSeries)}
        </LChart>
      </ResponsiveContainer>
    </div>
  )
}
export class BarChart extends Component {
  eachDataSeries = (item, index) =>
    item.key !== this.props.highlight && this.props.current[item.key] > 0 ? (
      <span
        key={String.GUID()}
        className={`pa1 ma1 fw4 f6 b dib bg-white o-80 br2 ${item.className ||
          ''}`}
      >
        {item.text}:{' '}
        {this.props.current[item.key].formatUnit(this.props.unit, ' ')}
      </span>
    ) : (
      false
    )
  eachSeries = (item, index) =>
    item.displayChart === false ? (
      false
    ) : (
      <Bar
        key={String.GUID()}
        dataKey={item.key}
        className={item.chartClassName || ''}
        isAnimationActiveBoolean={false}
        dot={false}
        fill={item.stroke}
        stackId="a"
      />
    )
  render = () => (
    <div className="chart-container w-100 relative fl w-100">
      {this.props.current && this.props.highlight ? (
        <div className="w-100 fl tc counters absolute">
          <span className="w-100 fl f5 fw4 tc o-80">
            {this.props.title ? this.props.title : null}
            <small className="f7">
              {this.props.unit ? ` (${this.props.unit})` : null}
            </small>
          </span>
          <span
            className={
              'w-100 fl ' + (this.props.highlightClassName || 'f2 fw6 tc pa0')
            }
          >
            {this.props.current[this.props.highlight].formatUnit(
              this.props.unit,
              ' '
            )}
          </span>
          <span className="w-100 status tc pa1 dib">
            {this.props.dataSeries.map(this.eachDataSeries)}
          </span>
        </div>
      ) : (
        false
      )}
      <ResponsiveContainer
        width="100%"
        height="100%"
        minHeight={this.props.minHeight || 130}
      >
        <BChart
          data={this.props.series}
          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
        >
          {this.props.dataSeries.map(this.eachSeries)}
          {X()}
          {Y(this.props.unit, this.props.max)}
        </BChart>
      </ResponsiveContainer>
    </div>
  )
}

export class GaugeChart extends Component {
  render = () => (
    <div className="chart-container fl w-100 relative flex items-center">
      <div className="w-100 fl flex tc gauge-legend absolute pa1">
        <span className="w-100 fl items-center pt3">
          <span className="w-100 fl f2 fw6 tc o-80 limit">
            {this.props.limit ? this.props.limit.withSeparator(',') : false}
          </span>
          <span className="w-100 fl f1 fw9 tc o-80 items-center value">
            {this.props.limit ? this.props.value.withSeparator(',') : false}
          </span>
          <span className="w-100 fl f6 fw6 tc o-80 pt2 center percent">
            <span
              className={
                'w-30 f5 fw6 tc br1 pa1 center ' +
                (this.props.percent > 0 ? 'bg-green' : 'bg-red')
              }
            >
              {this.props.percent
                ? this.props.percent.withSeparator(',', 1) + '%'
                : false}
            </span>
          </span>
          <span className="w-100 fl f3 fw6 tc o-80 pt2 title">
            {this.props.legend ? this.props.legend.toTitleCase() : false}
          </span>
        </span>
      </div>
      <ResponsiveContainer
        width="100%"
        height="100%"
        minHeight={this.props.minHeight || 320}
      >
        <PieChart>
          <Pie
            dataKey={'value'}
            data={this.props.data}
            cx={this.props.cx || 'auto'}
            cy={this.props.cy || 'auto'}
            endAngle={-50}
            startAngle={230}
            innerRadius={'80%'}
            outerRadius={'100%'}
            fill={this.props.color}
            paddingAngle={3}
          >
            {this.props.data.map((data, index) => (
              <Cell key={String.GUID()} stroke={data.fill} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/monitoring/components/charts/index.js